import { useEffect } from 'react';
import initLocalize from '../utils/initLocalize';

export default function useInitLocalize(initialize, addTranslationForLanguage) {
    useEffect(() => { initLocalize({ initialize, addTranslationForLanguage }); }, []);
}
